// dashboard.module.ts
import { SafePipe } from "./sanitize-html.pipe";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { MatBadgeModule } from "@angular/material/badge";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { StepperNavigationComponent } from "./../../components/stepper-navigation/stepper-navigation.component";

import {
  DialogApprove,
  RejectApprove,
  FormLayout,
  OutofofficeComponent,
} from "./outofoffice.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { RemoteWorkSchedulerComponent } from "./../../components/remote-work-scheduler/remote-work-scheduler.component";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
// Bileşen Tanımlamaları
import { MatTableExporterModule } from "mat-table-exporter";
// import { OutofofficeComponent } from "./outofoffice.component";
import { MatIconModule } from "@angular/material/icon";
import { DashboardContainerComponent } from "./dashboard-container.component";
import { PersonalDesktopComponent } from "./personal-desktop.component";
// import { OutofofficeComponent } from "./outofoffice.component";
// import { ManagementDesktopComponent } from "./management-desktop.component";

import { ShiftSchedulerComponent } from "../shift/shift-scheduler.component";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatStepperModule } from "@angular/material/stepper";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatSelectModule } from "@angular/material/select";
import { FormatDatetimeComponent } from "./../../components/format-datetime/format-datetime.component";
import { FormatTimeComponent } from "./../../components/format-time/format-time.component";
import { TextMaskModule } from "angular2-text-mask";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatRadioModule } from "@angular/material/radio";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatNativeDateModule } from "@angular/material/core"; // Tarih motoru için zorunludur
import { AuthGuard } from "../auth/auth.guard";
// import { SafePipe } from "./pages/outofoffice/sanitize-html.pipe";

// Angular 7 uyumlu alt router tanımlaması
const routes: Routes = [
  {
    path: "",
    component: DashboardContainerComponent,
    children: [
      { path: "", redirectTo: "summary", pathMatch: "full" },
      { path: "summary", component: PersonalDesktopComponent },
      { path: "approve", component: OutofofficeComponent },
      { path: "shift", component: ShiftSchedulerComponent },
    ],
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [
    MatTooltipModule,
    MatNativeDateModule,
    MatRadioModule,
    TextMaskModule,
    MatSelectModule,
    MatDatepickerModule,
    MatStepperModule,
    MatCheckboxModule,
    MatTableModule,
    MatSortModule,
    MatTableExporterModule,
    MatPaginatorModule,
    MatIconModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatBadgeModule,
    MatFormFieldModule, // 2. <mat-label> hatasını çözen ana modül
    MatInputModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    RouterModule.forChild([
      {
        path: "",
        component: DashboardContainerComponent,
        children: [
          { path: "", redirectTo: "summary", pathMatch: "full" },
          { path: "summary", component: PersonalDesktopComponent },
          { path: "approve", component: OutofofficeComponent },
          { path: "shift", component: ShiftSchedulerComponent },
        ],
        canActivate: [AuthGuard],
      },
    ]),
  ],
  declarations: [
    // SafePipe,
    FormatTimeComponent,
    RemoteWorkSchedulerComponent,
    FormatDatetimeComponent,
    StepperNavigationComponent,
    DashboardContainerComponent,
    PersonalDesktopComponent,
    OutofofficeComponent,
    ShiftSchedulerComponent,
    DialogApprove,
    // RejectApprove,
    // FormLayout,

    // ManagementDesktopComponent,
  ],
  entryComponents: [DialogApprove],

  //   imports: [CommonModule, FormsModule, RouterModule.forChild(routes)],
})
export class DashboardModule {}
